import { Outlet } from "react-router-dom";
import NetworkProvider from "@/context/NetworkProvider";
import ErrorBoundary from "./ErrorBoundary";
import ErrorFallback from "./component/ErrorFallback";

const ErrorWrapper = () => {
  return (
    <NetworkProvider>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Outlet />
      </ErrorBoundary>
    </NetworkProvider>
  );
};

export default ErrorWrapper;
